var _path, _rect, _rect2, _rect3, _rect4, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstancelogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 46,
    viewBox: "0 0 166 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.225 33V12.9754H56.5763V33H53.225ZM71.1296 33V25.7689C71.1296 25.2961 71.0971 24.7723 71.0322 24.1975C70.9673 23.6227 70.8144 23.0711 70.5733 22.5427C70.3416 22.005 69.9893 21.5646 69.5165 21.2216C69.053 20.8786 68.4226 20.7071 67.6253 20.7071C67.1988 20.7071 66.777 20.7766 66.3598 20.9157C65.9426 21.0547 65.5625 21.2958 65.2195 21.6388C64.8858 21.9725 64.6169 22.4361 64.413 23.0294C64.209 23.6135 64.1071 24.3644 64.1071 25.2822L62.1185 24.4339C62.1185 23.1546 62.3642 21.9957 62.8555 20.9574C63.3561 19.9191 64.0885 19.094 65.0527 18.4821C66.0168 17.861 67.2035 17.5504 68.6126 17.5504C69.7251 17.5504 70.6429 17.7358 71.366 18.1067C72.0891 18.4775 72.6639 18.9503 73.0903 19.5251C73.5168 20.0999 73.832 20.7117 74.0359 21.3607C74.2399 22.0096 74.3697 22.6261 74.4253 23.2102C74.4902 23.785 74.5226 24.2531 74.5226 24.6147V33H71.1296ZM60.714 33V17.9815H63.7038V22.64H64.1071V33H60.714ZM86.954 33C85.962 33.1854 84.9886 33.2642 84.0337 33.2364C83.0881 33.2179 82.2398 33.0464 81.4889 32.7219C80.738 32.3881 80.1678 31.8643 79.7785 31.1505C79.4354 30.5016 79.2547 29.8387 79.2361 29.1619C79.2176 28.4852 79.2083 27.7204 79.2083 26.8675V13.8097H82.5458V26.6728C82.5458 27.2754 82.5504 27.8038 82.5597 28.2581C82.5782 28.7123 82.6755 29.0831 82.8517 29.3705C83.1854 29.9268 83.7185 30.2373 84.4509 30.3022C85.1833 30.3671 86.0176 30.33 86.954 30.191V33ZM76.4827 20.6098V17.9815H86.954V20.6098H76.4827ZM90.1834 33V17.9815H93.1454V21.6388L92.7838 21.166C92.9692 20.6654 93.2149 20.2111 93.5209 19.8032C93.8361 19.386 94.2115 19.043 94.6472 18.7742C95.0181 18.5239 95.426 18.3292 95.871 18.1901C96.3252 18.0418 96.7888 17.9537 97.2616 17.9259C97.7344 17.8888 98.1933 17.9074 98.6383 17.9815V21.1104C98.1933 20.9806 97.6787 20.9389 97.0947 20.9852C96.5199 21.0316 96.0008 21.1938 95.5372 21.4719C95.0737 21.7222 94.6936 22.0421 94.3969 22.4314C94.1095 22.8208 93.8963 23.2658 93.7573 23.7664C93.6182 24.2578 93.5487 24.7908 93.5487 25.3656V33H90.1834ZM105.138 33.4172C104.054 33.4172 103.136 33.2132 102.385 32.8053C101.634 32.3881 101.064 31.8365 100.675 31.1505C100.295 30.4645 100.104 29.7089 100.104 28.8838C100.104 28.1607 100.225 27.5118 100.466 26.937C100.707 26.3529 101.078 25.8523 101.579 25.4351C102.079 25.0087 102.728 24.661 103.525 24.3922C104.128 24.1975 104.833 24.0214 105.639 23.8638C106.455 23.7062 107.336 23.5625 108.281 23.4327C109.236 23.2936 110.233 23.1453 111.271 22.9877L110.075 23.6691C110.084 22.6308 109.853 21.8659 109.38 21.3746C108.907 20.8832 108.11 20.6376 106.988 20.6376C106.311 20.6376 105.658 20.7952 105.027 21.1104C104.397 21.4256 103.956 21.9679 103.706 22.7374L100.647 21.7779C101.018 20.5078 101.722 19.488 102.761 18.7185C103.808 17.9491 105.217 17.5643 106.988 17.5643C108.323 17.5643 109.496 17.7822 110.506 18.2179C111.526 18.6536 112.281 19.3675 112.773 20.3594C113.042 20.8879 113.204 21.4302 113.26 21.9864C113.315 22.5334 113.343 23.1314 113.343 23.7803V33H110.409V29.746L110.896 30.2744C110.219 31.3591 109.426 32.1564 108.518 32.6663C107.618 33.1669 106.492 33.4172 105.138 33.4172ZM105.806 30.7472C106.566 30.7472 107.215 30.6128 107.753 30.344C108.29 30.0751 108.717 29.746 109.032 29.3566C109.357 28.9673 109.574 28.6011 109.686 28.2581C109.862 27.8316 109.959 27.3449 109.978 26.7979C110.006 26.2417 110.019 25.7921 110.019 25.449L111.048 25.755C110.038 25.9126 109.171 26.0516 108.448 26.1722C107.725 26.2927 107.104 26.4086 106.585 26.5198C106.066 26.6218 105.607 26.7377 105.208 26.8675C104.819 27.0065 104.489 27.1688 104.221 27.3542C103.952 27.5396 103.743 27.7528 103.595 27.9938C103.456 28.2349 103.386 28.5176 103.386 28.8421C103.386 29.2129 103.479 29.542 103.664 29.8294C103.85 30.1076 104.119 30.33 104.471 30.4969C104.833 30.6638 105.278 30.7472 105.806 30.7472ZM130.118 19.2887C130.118 20.9018 129.562 22.246 128.45 23.3214C127.356 24.3783 125.678 24.9067 123.416 24.9067H119.689V33H117.158V13.615H123.416C125.604 13.615 127.263 14.1435 128.394 15.2003C129.544 16.2572 130.118 17.62 130.118 19.2887ZM123.416 22.8208C124.825 22.8208 125.863 22.5149 126.531 21.903C127.198 21.2911 127.532 20.4197 127.532 19.2887C127.532 16.8969 126.16 15.7009 123.416 15.7009H119.689V22.8208H123.416ZM132.318 25.3239C132.318 23.7664 132.634 22.4036 133.264 21.2355C133.894 20.0489 134.757 19.1311 135.85 18.4821C136.963 17.8332 138.196 17.5087 139.549 17.5087C140.884 17.5087 142.043 17.7961 143.026 18.3709C144.009 18.9457 144.741 19.6688 145.223 20.5402V17.759H147.782V33H145.223V30.1632C144.723 31.0532 143.972 31.7948 142.97 32.3881C141.988 32.9629 140.838 33.2503 139.522 33.2503C138.168 33.2503 136.944 32.9166 135.85 32.2491C134.757 31.5816 133.894 30.6453 133.264 29.4401C132.634 28.2349 132.318 26.8628 132.318 25.3239ZM145.223 25.3517C145.223 24.2021 144.991 23.2009 144.528 22.348C144.064 21.4951 143.434 20.8462 142.637 20.4012C141.858 19.9376 140.996 19.7059 140.05 19.7059C139.104 19.7059 138.242 19.9284 137.464 20.3734C136.685 20.8183 136.064 21.4673 135.6 22.3202C135.137 23.1731 134.905 24.1743 134.905 25.3239C134.905 26.492 135.137 27.5118 135.6 28.3832C136.064 29.2361 136.685 29.8943 137.464 30.3579C138.242 30.8029 139.104 31.0253 140.05 31.0253C140.996 31.0253 141.858 30.8029 142.637 30.3579C143.434 29.8943 144.064 29.2361 144.528 28.3832C144.991 27.5118 145.223 26.5013 145.223 25.3517ZM165.186 17.759L156.008 40.1755H153.394L156.397 32.8331L150.251 17.759H153.06L157.844 30.1076L162.572 17.759H165.186Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 20,
    height: 20,
    rx: 5,
    fill: "url(#paint0_linear_10878_19275)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 20,
    height: 20,
    rx: 5,
    fill: "url(#paint1_linear_10878_19275)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 20,
    height: 20,
    rx: 5,
    fill: "url(#paint2_linear_10878_19275)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 20,
    height: 20,
    rx: 5,
    fill: "url(#paint3_linear_10878_19275)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 25C23 23.8954 23.8954 23 25 23H41.1716C42.9534 23 43.8457 25.1543 42.5858 26.4142L35.075 33.925L26.4142 42.5858C25.1543 43.8457 23 42.9534 23 41.1716V25Z",
    fill: "url(#paint4_linear_10878_19275)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 21C23 22.1046 22.1046 23 21 23H4.82843C3.04662 23 2.15429 20.8457 3.41422 19.5858L10.925 12.075L19.5858 3.41422C20.8457 2.15429 23 3.04662 23 4.82843V21Z",
    fill: "url(#paint5_linear_10878_19275)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10878_19275",
    x1: 16,
    y1: 35.5,
    x2: 39,
    y2: 28.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7236F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A778EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10878_19275",
    x1: 16,
    y1: 35.5,
    x2: 39,
    y2: 28.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7236F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A778EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10878_19275",
    x1: 16,
    y1: 35.5,
    x2: 39,
    y2: 28.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7236F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A778EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10878_19275",
    x1: 16,
    y1: 35.5,
    x2: 39,
    y2: 28.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1609AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D78EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10878_19275",
    x1: 26.45,
    y1: 48.875,
    x2: 52.9,
    y2: 40.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67F7DE",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BFFED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10878_19275",
    x1: 19.55,
    y1: -2.875,
    x2: -6.9,
    y2: 5.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67F7DE",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BFFED"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstancelogo);
export default __webpack_public_path__ + "static/media/instancelogo.b58e8e3677866609219fd7129ef71438.svg";
export { ForwardRef as ReactComponent };